(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('accountMenu', function($rootScope,
            $interval,
            $location,
            authService,
            urlUtils,
            dateUtil,
            cookieService,
            languageService,
            modalService,
            dashboardNotificationService,
            $route,
            accountMenuService,
            broker,
            postBookingLookup,
            resourceService,
            $window,
            $document) {
    return {
        restrict: 'E',
        replace: true,
        priority: 200,
        templateUrl: (el, attrs) => `partials/home/directivetemplate?type=accountmenu${attrs.forNavigationDrawer === 'true' ? 'sidebar' : ''}`,
        link(scope, el, attrs) {
            let menuOpen = false;

            scope.forNavigationDrawer = (attrs.forNavigationDrawer === 'true');
            scope.IsTouchDevice = $window.TRPCONFIG.IsTouchDevice;

            scope.selectedLanguage = cookieService.get('LANG') || 'en-GB';
            scope.limitAlerts = 2;
            scope.formatNotification = noti => dashboardNotificationService.formatNotification(noti);
            scope.showDashboardMenu = false;
            scope.showNotifications = false;
            scope.showDashboardMenuSidebar = true;
            scope.setLanguage = setLanguage;
            scope.setLanguagePreference = setLanguagePreference;
            scope.sidebarClass = function() { return menuOpen ? 'open' : ''; };
            scope.signOut = signOut;
            scope.user = authService.getUser();
            scope.userName = userName;
            scope.launchNotification = launchNotification;
            scope.launchContactForm = launchContactForm;
            scope.notificationClicked = notificationClicked;
            scope.toggleDashboardMenuSidebar = () => scope.showDashboardMenuSidebar = !scope.showDashboardMenuSidebar;
            scope.toggleNotification = () => {
                scope.showNotifications = !scope.showNotifications;
                scope.showDashboardMenu = false;
            };
            scope.toManage = toManage;
            scope.getResourceValue = resource => resourceService.get(resource);
            scope.formatNotification = notification => dashboardNotificationService.formatNotification(notification);

            //For EKH agent website
            scope.launchUserProfileSearch = launchUserProfileSearch;
            scope.launchUserProfileView = launchUserProfileView;
            scope.launchUserProfileCreate = launchUserProfileCreate;
            scope.bookingName = bookingName;
            scope.customerName = customerName;
            scope.manageBooking = manageBooking;
            scope.showSignOutAlert = false;

            // Skywards variables
            scope.skywardsDropPanel = skywardsDropPanel;
            scope.skywardsClosePanel = skywardsClosePanel;
            if (getUserDetails() && getUserDetails().data && getUserDetails().data.Contact) {
                scope.skywardsTitle = getUserDetails().data.Contact.Title;
                scope.skywardsFirstName = getUserDetails().data.Contact.FirstName;
                scope.skywardsLastName = getUserDetails().data.Contact.LastName;
                scope.skywardsLoyaltyId = getUserDetails().data.Contact.LoyaltyId;
                scope.skywardsTier = getUserDetails().data.Contact.Tier;
            } else if (sessionStorage.getItem('skywardsLoginUser')) {
                getUserDetailsFromSessionStorage();
            } else {
                let attempts = 0;
                const retry = $interval(() => {
                    attempts++;
                    const skywardsData = JSON.parse(sessionStorage.getItem('skywardsLoginUser'));
                    if (skywardsData && skywardsData.data) {
                        getUserDetailsFromSessionStorage();
                        $interval.cancel(retry);
                    }
                    if (attempts > 20) {
                        $interval.cancel(retry);
                    }
                }, 200);
            }

            scope.$on('auth:signin', function() {
                resetNotifications();
                scope.user = authService.getUser();
                sessionStorage.setItem('scope.user', JSON.stringify(scope.user));
            });

            scope.$on('auth:signout', function() {
                menuOpen = false;
                $rootScope.alerts = null;
                scope.user = authService.getUser();
                sessionStorage.removeItem('scope.user');
                checksigninstatus();
            });

            scope.$on('menuClicked', function() {
                menuOpen = !menuOpen;
                if (menuOpen) {
                    resetNotifications();
                }
            });

            resetNotifications();

            function checksigninstatus() {
                let user = sessionStorage.getItem('scope.user');
                if (!user) {
                    document.querySelector('.myb-search-signout').style.display = 'none';
                    document.querySelector('.myb-search-signin').style.display = 'block';
                } else {
                    document.querySelector('.myb-search-signout').style.display = 'block';
                    document.querySelector('.myb-search-signin').style.display = 'none';
                }
            }

            function setLanguagePreference(lang, id) {
                languageService.setLanguage(lang, id)
                    .then(() => {
                        if (TRPCONFIG.Domain.RedirectLanguageChangeToHomepage) {
                            window.location.href = '/?rl=1';
                        } else {
                            //window.location.href = this.$location.absUrl();
                            this.$route.reload();
                        }
                    });
            }

            function getUserDetailsFromSessionStorage() {
                const skywardsData = JSON.parse(sessionStorage.getItem('skywardsLoginUser'));
                if (skywardsData && skywardsData.data && skywardsData.data.Contact) {
                    scope.skywardsTitle = skywardsData.data.Contact.Title;
                    scope.skywardsFirstName = skywardsData.data.Contact.FirstName;
                    scope.skywardsLastName = skywardsData.data.Contact.LastName;
                    scope.skywardsLoyaltyId = skywardsData.data.Contact.LoyaltyId;
                    scope.skywardsTier = skywardsData.data.Contact.Tier;
                }
            }

            function getUserDetails() {
                return authService.getSkywardsUserDetails();
            }

            function setLanguage() {
                cookieService.set('LANG', scope.selectedLanguage, dateUtil.addDays(new Date(), 365));
                window.location.href = $location.absUrl();
            }

            function launchUserProfileSearch() {
                modalService.launch('partials/userprofile/Search', { promptUserSelection: false });
            }

            function launchUserProfileView() {
                modalService.launch('partials/userprofile/UpdateUserProfileModal');
            }

            function launchUserProfileCreate() {
                modalService.launch('partials/userprofile/CreateUserProfileModal');
            }

            function launchNotification() {
                accountMenuService.launchNotification(scope.alerts);
                scope.closeMenu();
            }

            function launchContactForm() {
                accountMenuService.launchContactForm(scope.alerts);
                scope.closeMenu();
            }

            function userName() {
                if (!scope.user) {
                    return '';
                }
                if (scope.user.FirstName && scope.user.LastName) {
                    return `${scope.user.FirstName} ${scope.user.LastName}`;
                }
                let bookingId = authService.getSignedInBookingId();
                if (bookingId && scope.user.Contact && scope.user.Contact.SiteId) {
                    return `${scope.user.Contact.SiteId}/${bookingId}`;
                }
                return scope.user.Email;
            }

            function bookingName() {
                let bookingId = authService.getSignedInBookingId();
                if (bookingId) {
                    return `${this.user.Contact.SiteId}/${bookingId}`;
                }
            }

            function customerName() {
                if (scope.user.SignedIn && scope.user.LastName) {
                    return `${scope.user.FirstName} ${scope.user.LastName}`;
                }
            }

            function manageBooking() {
                if (scope.user.AnonSignedIn) {
                    return postBookingLookup.redirect();
                }
            }

            function resetNotifications() {
                const user = authService.getUser();
                if (TRPCONFIG.Domain.DashboardBookingEnabled && TRPCONFIG.Domain.SideBarNotificationEnabled && (user.AnonSignedIn || user.HardSignedIn)) {
                    dashboardNotificationService.getNotifications()
                        .then(data => $rootScope.alerts = data);
                }
            }

            function notificationClicked(noti) {
                scope.closeMenu();

                scope.showDashboardMenu = false;
                scope.showNotifications = false;

                dashboardNotificationService.notificationClicked(noti);
            }

            function signOut() {
                return authService.signOut().then(() => {
                    broker.publish('hideNavigationDrawer');
                    scope.showDashboardMenu = false;
                });
            }

            function toManage() {
                let user = sessionStorage.getItem('scope.user');
                if (!user) {
                    sessionStorage.setItem('scope.user', JSON.stringify(scope.user));
                }

                scope.closeMenu();
                const cookieName = authService.createCookieName();
                authService.doesHttpOnlyCookieExist(cookieName);
                scope.showDashboardMenu = false;
                scope.showNotifications = false;

                if (scope.user.AnonSignedIn && !scope.user.SignedIn) {
                    return postBookingLookup.redirect();
                }
                if (!scope.user.AnonSignedIn && scope.user.SignedIn) {
                    return $location.path('dashboard/bookings/current');
                }
                return accountMenuService.launchOption('bookingsignin');
            }

            scope.subMenuTriggerMouseenter = function(e, booleanName) {
                // open on mouseenter for non-touch only
                if (!scope.forNavigationDrawer && !scope.IsTouchDevice) {
                    scope[booleanName] = true;
                }
            };

            scope.subMenuTriggerMouseleave = function(e, booleanName) {
                // close on mouseleave for non-touch only
                if (!scope.forNavigationDrawer && !scope.IsTouchDevice) {
                    scope[booleanName] = false;
                }
            };

            scope.subMenuTriggerClick = function(e, booleanName) {
                // toggle on click for touch devices only
                if (!scope.forNavigationDrawer && scope.IsTouchDevice) {
                    scope[booleanName] = !scope[booleanName];
                    if (scope[booleanName]) {
                        e.stopPropagation();
                        // close sub menu when anything else is clicked
                        $document.one('click.accountMenu', () => {
                            scope.$apply(scope[booleanName] = false);
                        });
                    }
                }
            };

            scope.dashboardLinkClick = function() {
                broker.publish('hideNavigationDrawer');
                scope.showDashboardMenu = false;
            };

            scope.hideSignOutAlert = function() {
                scope.showSignOutAlert = false;
            };

            scope.signOutAlert = function() {
                scope.showSignOutAlert = true;
            };

            scope.closeMenu = () => {
                menuOpen = false;
                broker.publish('hideNavigationDrawer');
            };

            function skywardsDropPanel(skywardsFirstName, skywardsLastName, skywardsLoyaltyId, skywardsTier) {
                if (skywardsFirstName && skywardsLastName && skywardsLoyaltyId && skywardsTier) {
                    let element = document.querySelector('.skywards-sub-menu');
                    element.classList.toggle('open');
                }
            }

            function skywardsClosePanel() {
                let element = document.querySelector('.skywards-sub-menu');
                if (element.classList.contains('open')) {
                    element.classList.remove('open');
                }
            }
        }
    };
});
})();
